import getP13nData from 'services/api/p13n/getP13nData';
import getP13nNbcData from 'services/api/p13n/getP13nNbcData';

export default { getP13nData, getP13nNbcData };
